import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVimComponent } from './simple-icons-vim.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVimComponent ],
    exports:      [ SimpleIconsVimComponent ],
    bootstrap:    []
})
export class SimpleIconsVimModule {}
